import React, { Component } from 'react';
import { Dropdown } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { getTeamParamFromUrl } from '../Constants/getTeamParam';

const TEAM_STORAGE_KEY = 'activeTeamHash';

class SwitchTeamsDropdown extends Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        // If URL has ?team=, make it the source of truth and persist
        const urlTeam = getTeamParamFromUrl();
        if (urlTeam && urlTeam.trim() !== '') {
            localStorage.setItem(TEAM_STORAGE_KEY, urlTeam);
        } else {
            // If no ?team= and nothing stored, ensure clean default state
            const stored = localStorage.getItem(TEAM_STORAGE_KEY);
            if (!stored) {
                localStorage.removeItem(TEAM_STORAGE_KEY);
            }
        }
    }

    // Build options where each option value is the team_hash (fallback to id string)
    buildTeamOptions = () => {
        const teams = this.props.teamInfo || [];
        const teamOpts = teams.map((t) => {
            const value = String(t.team_hash || t.id);
            return {
                key: value,
                value: value,
                text: t.name || 'Team',
            };
        });

        // Default option at the top (value = "-1")
        teamOpts.unshift({ key: '-1', value: '-1', text: 'Default' });
        return teamOpts;
    };

    // Compute current dropdown value from localStorage
    getCurrentValue = () => {
        const teams = this.props.teamInfo || [];
        const stored = localStorage.getItem(TEAM_STORAGE_KEY);

        if (!stored) return '-1'; // Default

        // Validate that stored hash/id exists in current team list; else fall back to Default
        const exists = teams.some((t) => String(t.team_hash || t.id) === String(stored));
        return exists ? stored : '-1';
    };

    // Add/remove ?team=… and refresh
    applyTeamQueryParamAndRefresh = (teamValue) => {
        const url = new URL(window.location.href);

        if (teamValue === '-1') {
            // Default: remove param and stored value
            url.searchParams.delete('team');
            localStorage.removeItem(TEAM_STORAGE_KEY);
            window.location.replace(url.toString());
            return;
        }

        // Persist and set param, then refresh
        localStorage.setItem(TEAM_STORAGE_KEY, teamValue);
        url.searchParams.set('team', teamValue);
        window.location.replace(url.toString());
    };

    onChange = (e, { value }) => {
        this.applyTeamQueryParamAndRefresh(value);
    };

    render() {
        const options = this.buildTeamOptions();
        const value = this.getCurrentValue();

        return (
            <span
                style={{
                    zIndex: '999',
                    fontSize: '115%',
                    marginTop: '6px',
                    color: this.props.color,
                    border: '1px solid ' + this.props.color,
                    padding: '4px',
                    borderRadius: '4px',
                }}
            >
        <Dropdown options={options} onChange={this.onChange} value={value} inline />
      </span>
        );
    }
}

const mapStateToProps = (state) => ({
    // Keep teamInfo from Redux (or pass it in from parent if you prefer)
    teamInfo: state.mainState.teamInfo,
});

// No actions needed anymore
export default connect(mapStateToProps)(SwitchTeamsDropdown);
